<template>
  <div class="wrongbookpay">
    <div class="content">
      <div class="banner">
        <div class="userinfo">
          <template v-if="book_vip == 1">
            <img :src="avatar || df_avatar" />
            <div>
              <div class="nickname">{{ name }}</div>
              <div class="desc">已开通（{{ book_vip_end }} 到期）</div>
            </div>
          </template>
          <template v-else>
            <div>
              <div class="vip-tip">
                已有<span class="themeColor">2万+</span>用户成功开通
              </div>
              <div class="vip-desc">
                开通后你可以拥有以下权益
              </div>
            </div>
          </template>
        </div>
      </div>

      <div class="tabs">
        <div
          v-for="(item, index) in tabs"
          :key="index"
          @click="changeTab(index)"
          class="tab-item"
          :class="{ active: tabIndex === index }"
        >
          <img class="tab-left" :src="item.icon" alt="tab-icon" />
          <span>{{ item.title }}</span>
        </div>
      </div>

      <div class="notice" :class="{ active: tabIndex === 0 }">
        <div
          class="notice-item"
          :class="{'red-point': item.red}"
          v-for="(item, index) in (tabIndex == 0 ? noticeLists : passList)"
          :key="index"
        >
          <div class="item-title">{{ item.title }}</div>
          <div class="item-desc">
            {{ item.desc
            }}<span
              class="pointerLink"
              v-if="item.red"
              @click="contactService"
              >联系客服
            </span>
          </div>
        </div>
      </div>

      <div class="productList">
        <div class="swiper-item">
              <div
                v-for="(item, index) in productList"
                :key="index"
                :class="[
                  'price-item',
                  index === productIndex ? 'curr-select' : null
                ]"
                @click="changeProduct(index)"
              >
                <div class="price-desc">{{ item.name }}</div>
                <div class="price-now">
                  <span>￥</span><span class="price-num">{{ item.price }}</span>
                </div>
                <div v-if="item.discount" class="price-old">
                  {{ item.discount }}
                </div>
                <div v-if="item.info" class="cen-discount">{{ item.info }}</div>
              </div>
            </div>
        <!-- <div
          :class="
            productIndex == index ? 'active product-item ' : 'product-item '
          "
          :style="!isMobile ? 'minWidth:106px' : ''"
          v-for="(item, index) in productList"
          :key="index"
          @click="changeProduct(index)"
        >
          <div>
            <div class="name">{{ item.name }}</div>
            <div class="price">
              <span class="price-icon">¥</span>{{ item.price }}
            </div>
            <div class="discount">{{ item.discount }}</div>
            <div class="info" v-if="item.info">{{ item.info }}</div>
            <img
              v-if="productIndex == index"
              src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220415/447a645f8ccf856b2edf9db4d16923a0.svg"
            />
          </div>
        </div> -->
      </div>
      <div class="mask-box" v-if="showModal">
        <div class="mask-content">
          <div class="confirm-header">
            {{ buyInfo }} <br />
            到期时间: {{ b_time }}
          </div>

          <div class="confirm-footer">
            <div class="confirm-cancel" @click="closeConfirm">我知道了</div>
            <div class="confirm-ok" click="confirmOk">
              <template>
                <span class="goWx" @click="getWxSchema(1)">前往小程序</span>
              </template>
            </div>
          </div>
        </div>
      </div>
      <ContactImg :visible="showContact" @hideVisible="handleContact()" />
      <template v-if="showLogin">
        <ScanLogin
          @hideVisible="handleScan()"
          :type="qrcodeType"
          :targetIndex="productIndex"
          :src="loginQrcode"
          :productList="productList"
          :payType="payType"
        />
      </template>
      <van-popup v-model="bindVisible" position="bottom" duration="0.1">
        <get-phone @bindSuccess="bindSuccess" @hideVisible="handleBind()" />
      </van-popup>
      <template v-if="showScan">
        <scan-code
          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-04/835fdbe5ba8e7fdb70d95ea5ede9a0ee.png"
          @hideVisible="handleScanCode"
        ></scan-code>
      </template>

      <template v-if="!isMobile">
        <right-code
          desc="微信扫一扫，前往开通错题本"
          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-03/186715399b8ede4abcdf09c361e3689f.jpg"
        />
      </template>
    </div>
    <div class="footer" v-if="productList.length">
      <div class="buy-btn">
        <!-- <div class="give" @click="give">
          <img
            class="give-icon"
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-01-12/7059c862b501043feb2c589fdb2d4852.png"
            alt=""
          />
          <div>赠送错题本</div>
        </div> -->
        <button @click="pay">
          <span class="price-icon">¥</span
          >{{ productList[productIndex].price }} 元立即{{ book_vip ? "续费" : "开通" }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import questionOnly from "@/utils/questionOnly";
import {
  jumpWxAuth,
  getToken,
  formatDateTime,
  isMobile,
  isWeixin,
  verifyAuth,
  getWxUrl,
  showServiceAble,
  getQueryString,
  handleCode,
  wrongbookClick
} from "@/utils/common";
import { df_avatar } from "@/utils/config";
import api from "@/utils/api";
import { Toast, Dialog } from "vant";
import ContactImg from "@/components/contactImg";
import RightCode from "../../components/rightCode.vue";
import ScanLogin from "@/components/scanLogin";
import ScanCode from "@/components/scanCode.vue";
import GetPhone from "../../components/getphone.vue";
import { throttle } from "lodash";
import { handleZI } from "../../utils/common";

let checkTime = 0;
let intervalAsk;
export default {
  data() {
    return {
      tabIndex: 0,
      tabs: [
        {
          icon:
            "https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-04-23/87b1c128c0981927cb90d1bff48b8046.png",
          title: "错题本"
        },
        {
          icon:
            "https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-04-23/5a9f9d0ad9f6a2228594246386c77145.png",
          title: "作答免排队"
        }
      ],
      passList: [{ title: '说明', desc: '同时作答人数达到上限时，可直接参与作答，无需排队等待' },{ title: '服务条款', desc: '仅当前账号使用。开通完成后，不可进行转让或要求退费。仍有问题请', red: 1 }],
      payType: 1,
      showScan: false,
      showLogin: false,
      loginQrcode: "",
      qrcodeType: 0,
      showRightCode: false,
      isWeixin: isWeixin(),
      isMobile: isMobile(),
      showContact: false,
      buyInfo: "",
      showModal: false,
      path: "/pages/wrongbook/wrongbooklist/wrongbooklist",
      name: "立吉答题用户",
      avatar: "",
      df_avatar,
      book_vip: 0,
      book_vip_start: "",
      book_vip_end: "",
      productIndex: 1,
      b_time: "",
      productList: [],
      hasUserInfo: false,
      bindVisible: false,
      phone: "",
      noticeLists: [{ title: '查看练习', desc: '无限制查看/练习错题本内全部题目' }, { title: '添加上传', desc: '可自主上传导入多种格式题目（Word、Excel、图片、文本）' }, { title: '导出打印', desc: '所有错题支持导出PDF文件方便打印' }, { title: '批量管理', desc: '批量移除错题本中的题目，重新整理，方便复习' }, { title: '系统题库', desc: '10万海量题目，支持自选加入练习' }, { title: '服务条款', desc: '错题练习不会影响已有成绩，若出题人设置了不允许加入错题本或不展示答案解析，则无法操作/查看，请仔细核对。开通完成后，不可进行转让或要求退费。仍有问题请',red: 1 }],
    };
  },
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    ContactImg,
    RightCode,
    ScanLogin,
    ScanCode,
    GetPhone
  },

  methods: {
    changeTab(e) {
      this.tabIndex = e;
    },
    contactService() {
      this.handleContact();
    },
    give() {
      Dialog.confirm({
        title: "",
        message: "支持给他人赠送错题本功能，可同时赠送多位，联系客服协助开通",
        confirmButtonText: "联系客服",
        cancelButtonColor: "#999999",
        cancelButtonText: "我知道了",
        confirmButtonColor: "#1890FF"
      })
        .then(() => {
          this.handleContact();
        })
        .catch(() => {});
    },
    bindSuccess(phone) {
      this.phone = phone;
      this.bindVisible = false;
      this.pay();
    },
    handleBind() {
      this.bindVisible = !this.bindVisible;
    },
    async getWxSchema(type) {
      if (this.isMobile) {
        let path = "pages/wrongbook/wrongbooklist/wrongbooklist";
        let url = await getWxUrl(path, type ? "" : 1, 1);
        if (url) window.location.href = url;
      } else {
        this.showModal = false;
        this.handleScanCode();
      }
    },
    getProduct() {
      questionOnly
        .get("/xcx/ques/v2/produce/detail", { type: 2, loadingMsg: "no" })
        .then(res => {
          if (res.sta == 0) {
            if (res.data.product_list) {
              let product_list = res.data.product_list || [];
              if (!localStorage.getItem("continue_pay")) {
                let checkedIndex = 0;
                product_list.forEach((item, index) => {
                  if (item.checked) {
                    checkedIndex = index;
                  }
                });
                this.productIndex = checkedIndex;
              }
              this.productList = product_list;
            }
          }
        });
    },
    getLoginCode() {
      var timestamp = new Date().getTime();
      var myToken =
        timestamp + Math.ceil(Math.random() * 1000000000000000) + "";
      // 获取二维码  开始轮询请求，如果返回ok，清除轮询
      questionOnly
        .get("/xcx/ques_web/v1/qrcode", { token: myToken })
        .then(res => {
          if (res.sta == 0) {
            this.loginQrcode = res.data.qrcode;
            this.qrcodeType = 0;
            if (!this.showLogin) this.showLogin = true;
            checkTime = 0;
            this.checkLoginSuccess(myToken);
          } else {
            Toast(res.msg || "请求失败");
          }
        });
    },
    getPayCode() {
      questionOnly
        .post("/xcx/ques/v1/order", {
          access_token: getToken(),
          type: "wrong_book_v2",
          duration: this.productList[this.productIndex].days,
          pay_source: 1 // 付费来源 1:h5, 2:pc, 3:腾讯会议, 默认为1
        })
        .then(res => {
          if (res.sta == 0) {
            this.loginQrcode = res.data.qrcode;
            this.qrcodeType = 1;
            this.showLogin = true;
            checkTime = 0;
            this.checkPaySuccess(res.data.order_id);
          } else {
            Toast(res.msg || "请求失败");
          }
        });
    },
    checkPaySuccess(order_id) {
      clearTimeout(intervalAsk);
      checkTime++;
      if (checkTime > 20) {
        checkTime = 0;
        this.getPayCode();
        return;
      }
      questionOnly
        .get("/xcx/ques/v1/order_status", {
          access_token: getToken(),
          order_id,
          loadingMsg: "no"
        })
        .then(res => {
          if (res.sta === -1) {
            intervalAsk = setTimeout(() => {
              this.checkPaySuccess(order_id);
            }, 3000);
          } else {
            wrongbookClick("h5_pay", "H5购买");
            // 支付成功
            this.showLogin = false;
            let duration = this.productList[this.productIndex].days;
            let b_end = "";
            if (this.book_vip) {
              b_end =
                new Date(this.book_vip_end).getTime() + duration * 86400000;
            } else {
              b_end = new Date().getTime() + duration * 86400000;
            }
            b_end = formatDateTime(b_end, 3);
            let buyInfo = this.book_vip ? "续费成功" : "开通成功";
            this.showModal = true;
            this.b_time = b_end;
            this.buyInfo = buyInfo;
            this.handleUserInfo("refresh");
          }
        });
    },
    checkLoginSuccess(myToken) {
      clearTimeout(intervalAsk);
      checkTime++;
      if (checkTime > 20) {
        checkTime = 0;
        this.getLoginCode();
        return;
      }
      questionOnly
        .get("/xcx/ques_web/v1/check_status", {
          token: myToken,
          loadingMsg: "no"
        })
        .then(res => {
          if (res.sta === -1) {
            intervalAsk = setTimeout(() => {
              this.checkLoginSuccess(myToken);
            }, 3000);
          } else {
            // 登录成功
            localStorage.setItem("token", res.data.access_token);
            handleZI(res.data.mp_openid);
            setTimeout(() => {
              this.showLogin = false;
              this.handleUserInfo();
            }, 100);
          }
        });
    },
    handleScanCode() {
      this.showScan = !this.showScan;
    },
    handleScan() {
      if (intervalAsk) {
        clearInterval(intervalAsk);
        intervalAsk = null;
      }
      this.showLogin = !this.showLogin;
    },
    async handleContact() {
      let res = await showServiceAble();
      if (res) {
        this.showContact = !this.showContact;
      }
    },
    showPanel() {
      this.showContact = true;
    },
    closeConfirm() {
      this.showModal = false;
    },
    handleLaunchFn() {},
    handleErrorFn() {},
    // 价格切换

    changeProduct: throttle(
      async function(e) {
        this.productIndex = e;
        this.pay();
      },
      2000,
      { trailing: false }
     ),
    //获取用户信息
    handleUserInfo(refresh) {
      let param = { access_token: getToken() };
      if (refresh) {
        param.refresh = 1;
      }
      questionOnly.get(api.question.getServiceDetail, param).then(res => {
        if (res.sta == 0) {
          let {
            name,
            avatar,
            book_vip_start,
            book_vip_end,
            book_vip,
            phone
          } = res.data;
          this.phone = phone;
          this.hasUserInfo = true;
          this.name = name;
          this.avatar = avatar;
          this.book_vip_start = formatDateTime(book_vip_start * 1000, 3);
          this.book_vip_end = formatDateTime(book_vip_end * 1000, 3);
          this.book_vip = book_vip;
          let continue_pay = localStorage.getItem("continue_pay") || 0;
          let continue_pay_index =
            localStorage.getItem("continue_pay_index") || 1;
          if (continue_pay) {
            this.productIndex = continue_pay_index * 1;
            localStorage.removeItem("continue_pay");
            localStorage.removeItem("continue_pay_index");
            this.pay();
          }
        } else if (res.sta == -500) {
          jumpWxAuth();
        }
      });
    },
    // 支付
    pay: throttle(
      async function() {
        if (!this.isWeixin) {
          if (this.isMobile) {
            return this.getWxSchema();
          } else {
            if (!this.hasUserInfo) {
              return this.getLoginCode();
            } else {
              // if (!this.phone) return (this.bindVisible = true);
              return this.getPayCode();
            }
          }
        } else if (this.isWeixin && !this.hasUserInfo) {
          // 微信里面没登录
          localStorage.setItem("continue_pay_index", this.productIndex);
          localStorage.setItem("continue_pay", 1);
          return jumpWxAuth();
        }
        if (!this.isMobile) {
          // if (!this.phone) return (this.bindVisible = true);
          return this.getPayCode();
        }
        // if (!this.phone) return (this.bindVisible = true);
        let self = this;
        let duration = this.productList[this.productIndex].days;
        let book_vip = this.book_vip;
        let param = {
          access_token: getToken(),
          type: "wrong_book_v2",
          source: "h5",
          duration
        };
        questionOnly.post(api.question.bookVipBuy, param).then(res => {
          if (res.sta == 0) {
            wrongbookClick("h5_pay", "H5购买");
            this.console = JSON.stringify(res.data);
            let b_end = "";
            if (book_vip) {
              b_end =
                new Date(this.book_vip_end).getTime() + duration * 86400000;
            } else {
              b_end = new Date().getTime() + duration * 86400000;
            }
            b_end = formatDateTime(b_end, 3);
            let buyInfo = book_vip ? "续费成功" : "开通成功";
            window.wx.chooseWXPay({
              timestamp: res.data.timeStamp,
              nonceStr: res.data.nonceStr,
              package: res.data.package,
              signType: res.data.signType,
              paySign: res.data.paySign,
              appId: res.data.appId,
              success: function(res) {
                self.showModal = true;
                self.b_time = b_end;
                self.buyInfo = buyInfo;
                self.handleUserInfo("refresh");
              },
              fail: error => {
                Toast(error.errMsg);
              },
              cancel: message => {
                // Toast(message.errMsg)
              }
            });
          } else {
            Toast(res.msg);
          }
        });
      },
      2000,
      { trailing: false }
    )
  },
  async mounted() {
    if (intervalAsk) {
      clearInterval(intervalAsk);
      intervalAsk = null;
    }
    this.getProduct();
    let loginStatus = await verifyAuth();
    if (loginStatus) {
      this.handleUserInfo();
    } else {
      if (this.isWeixin) {
        if (getToken()) {
          jumpWxAuth();
        } else {
          if (!getToken() && getQueryString("code")) {
            let res = await handleCode(getQueryString("code"));
            if (res) {
              this.handleUserInfo();
              return;
              // let arr = document.location.toString().split("&code=")[0];
              // window.location.replace(arr);
            }
            return;
          }
        }
      } else {
        if (!this.isMobile) {
          // pc
          this.getLoginCode();
        }
      }
    }
  },
  destroyed() {
    if (intervalAsk) {
      clearInterval(intervalAsk);
      intervalAsk = null;
    }
  }
};
</script>

<style scoped lang="scss">
.wrongbookpay {
  background: #ffffff;
  max-width: 500px;
  min-width: 320px;
  position: relative;
  min-height: 100vh;
  margin: 0 auto;
}

.content {
  background: white;
  padding: 12px 15px 80px;
  position: relative;
  min-height: 568px;
  box-sizing: border-box;
}
.banner {
  background: #f6fbff;
  box-sizing: border-box;
  border-radius: 10px;
  background-size: 100% 100%;
  margin: 0 0 10px;
  padding: 15px 25px 15px 15px;
  color: #262626;
}

.userinfo {
  display: flex;
  align-items: center;
}

.userinfo img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 5px;
  border: 2px solid #ffffff;
}

.nickname {
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
}
.handle {
  position: relative;
  font-size: 12px;
  line-height: 18px;
  padding-top: 40px;
}

.handle button {
  width: 100px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  position: absolute;
  right: 0;
  background: #ffffff;
  border-radius: 20px;
  font-size: 15px;
  top: 30px;
  color: #000000;
}
#launch-btn {
  width: 100px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  position: absolute;
  right: 0;
  background: #ffffff;
  border-radius: 20px;
  font-size: 15px;
  top: 30px;
  color: #000000;
}
.desc {
  font-size: 12px;
  line-height: 18px;
}

.notice {
  font-size: 14px;
  background: #ffffff;
  border-radius: 4px;
  padding: 5px;
  background: #f6fbff;
  border-radius: 10px 0 10px 10px;
}
.notice.active {
  border-radius: 0 10px 10px 10px;
}

.notice .btn-manage {
  color: #1890ff;
  font-size: 13px;
  display: inline;
}

.notice-item {
  padding: 10px 15px;
  position: relative;
}

.item-title {
  font-size: 14px;
  line-height: 25px;
  position: relative;
  padding-left: 10px;
}

.item-title:before {
  position: absolute;
  content: "";
  top: 10px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #1890ff;
}

.item-desc {
  font-size: 13px;
  line-height: 20px;
  color: #999999;
}

.notice-header {
  font-size: 15px;
  font-weight: 500;
  line-height: 14px;
  padding: 15px;
}

.notice .notice-item:nth-child(2n + 1) {
  background: #f6fbff;
}


.productList {
  overflow-y: auto;
  padding-bottom: 20px;
  margin: 15px 5px 0 0;
}

.product-item {
  background: #f8f8f8;
  // background: #ffffff;
  border-radius: 4px;
  height: 115px;
  min-width: 95px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  box-sizing: border-box;
  border: 2px solid transparent;
  margin-bottom: 15px;
  margin-right: 20px;
  padding-top: 5px;
  // box-shadow: 0 1px 8px rgba(0, 0, 0, 0.08);
}
.product-item.active {
  border: 2px solid #1890ff;
  color: #1890ff;
  background: #e7f8fe;
}
.product-item:last-child {
  margin-right: 0;
}
.product-item img {
  width: 28px;
  height: 28px;
  position: absolute;
  right: -2px;
  bottom: -2px;
}

.name {
  font-size: 14px;
  line-height: 14px;
}

.price {
  font-weight: 900;
  font-size: 20px;
  line-height: 23px;
  color: #1890ff;
  margin-top: 2px;
}
.price-icon {
  font-size: 12px;
}

.discount {
  font-size: 12px;
  line-height: 18px;
  text-decoration-line: line-through;
  color: #999999;
}
.info {
  position: absolute;
  left: -2px;
  top: -2px;
  background: #fe523c;
  padding: 0 8px;
  border-radius: 4px 0px 15px 0px;
  font-size: 12px;
  height: 17px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  text-align: center;
  color: #ffffff;
}
.footer {
  position: fixed;
  left: auto;
  bottom: 0;
  background: #ffffff;
  margin-top: 20px;
  max-width: 500px;
  width: 100%;
}
.buy-btn {
  padding: 10px 15px;
  box-sizing: border-box;
  border-top: 1px solid #eeeeee;
  display: flex;
  align-items: center;
}
.footer-tip {
  font-size: 12px;
  color: #999999;
  padding: 10px 15px;
}
.buy-btn button {
  height: 45px;
  line-height: 45px;
  background: #1890ff;
  border-radius: 20px;
  font-weight: bold;
  font-size: 16px;
  text-align: center;
  color: #ffffff;
  flex: 1;
  display: inline-block;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.buy-btn button::before {
  content: "";
  position: absolute;
  left: -75px;
  top: -230px;
  width: 345px;
  height: 45px;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0));
  transform: rotate(-45deg);
  animation: searchLights 2s ease-in 0.5s infinite;
}

@keyframes searchLights {
  0% {
    left: -250px;
    top: 0;
  }
  to {
    left: 345px;
    top: 0px;
  }
}
.mask-box {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 45px;
  z-index: 9;
}
.mask-content {
  background: white;
  width: 330px;
  box-sizing: border-box;
  border-radius: 8px;
  text-align: center;
}
.confirm-header {
  font-size: 16px;
  padding: 30px 0;
  color: #262626;
}
.confirm-bd {
  text-align: center;
  color: #666;
  font-size: 14px;
  line-height: 20px;
  padding-bottom: 30px;
}
.confirm-footer {
  // margin: 25px;
  /*width: px580);*/
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #eeeeee;
}
.confirm-footer div {
  flex: 1;
  text-align: center;
  line-height: 50px;
  font-weight: initial;
  font-size: 16px;
  font-weight: bold;
}
.confirm-cancel {
  color: #999999;
  font-weight: initial !important;
}
.confirm-ok {
  color: #1890ff;
  line-height: 50px;
  border-left: 1px solid #eee;
}
.goWx {
  height: 100%;
  display: block;
  line-height: 50px;
}
.give {
  text-align: center;
  font-size: 12px;
  line-height: 20px;
  margin-right: 15px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.give-icon {
  width: 24px;
  height: 24px;
}
.vip-tip {
  font-size: 16px;
  font-weight: bold;
  line-height: 19px;
  margin-bottom: 5px;
}
.vip-desc {
  font-size: 13px;
  color: #666666;
}
.tabs {
  display: flex;
  margin: 0 auto;
  cursor: pointer;
}
.tab-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  height: 60px;
  box-sizing: border-box;
  border-radius: 10px 10px 0 0;
  font-size: 16px;
  padding: 0 10px;
}
.tab-item.active {
  background: #f6fbff;
}
.tab-left {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.notice-item:last-child {
  border-radius: 0 0 10px 10px;
}
.notice .red-point:last-child .item-title:before {
  background: #FE523C;
}
.swiper-item {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  width: 400px;
  line-height: 1.15;
  .slider-list {
    margin: 0 15px !important;
  }
  .price-item {
    width: 90px;
    height: 115px;
    border: 1px solid #e6e6e6;
    border-radius: 10px;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-right: 10px;
    position: relative;
    .price-desc {
      font-weight: 600;
      font-size: 14px;
      color: #333;
      padding-top: 25px;
    }
    .price-now {
      padding: 5px 0;
      font-size: 14px;
      color: #333;
      font-weight: 700;
      .price-num {
        font-size: 24px;
        font-weight: 700;
      }
    }
    .price-old {
      font-size: 12px;
      color: #999;
      text-decoration: line-through;
    }
    .cen-discount {
      position: absolute;
      right: -1px;
      bottom: 0px;
      height: 18px;
      padding: 0 5px;
      line-height: 20px;
      background-color: #ff3333;
      color: #fff;
      border-radius: 10px 0px 10px 0px;
      text-align: center;
      font-size: 12px;
    }
  }
  .curr-select {
    background-color: #f2fbfe;
    border-color: #1890ff;
    .price-now {
      color: #1890ff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/wrongbook/servicebuy.vue